import QuestionValueBoolean from "../QuestionValueBoolean";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleBoolean extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        question.values = [new QuestionValueBoolean(P3.math.randomInt(0, 1))];

        this.generateOptions(question);
        return question;
    }

    generateOptions(question, total) {
        question.options = [new QuestionValueBoolean(1), new QuestionValueBoolean(0)];
    }
}